import { SAT_BOOTCAMP_ONBOARDING_TOPIC, SessionMentorStatus } from '@/queries/constants'

export const TUTOR_NO_SHOW_THRESHOLD_MINUTES_MIN = 15

export const ZOOM_DATA_RETENTION_DAYS = 30

// Tutor cannot miss more than TUTOR_NO_SHOW_COUNT_LIMIT sessions
// in TUTOR_NO_SHOW_COUNT_TIMEFRAME_DAYS days.
export const TUTOR_NO_SHOW_COUNT_LIMIT = 3
export const TUTOR_NO_SHOW_COUNT_TIMEFRAME_DAYS = 30

export const SESSION_JOIN_EARLY_MINUTES = 15

export const SESSION_TITLE_MIN_CHARS = 5

export const SESSION_TITLE_MAX_CHARS = 60

export const SERIES_DESCRIPTION_MIN_CHARS = 50

export const BASE_TRAINING_URL = 'https://coda.io/@shw/tutor-training'

export const SESSION_MENTOR_STATUS_TO_LABEL: Record<SessionMentorStatus, string> = {
  [SessionMentorStatus.InProgress]: 'In Progress',
  [SessionMentorStatus.NeedsMentor]: 'Needs Mentor',
  [SessionMentorStatus.Resolved]: 'Resolved',
  [SessionMentorStatus.None]: 'None',
}

export const SESSION_REQUESTS_DISABLED = true

export const ZOOM_NAME_DROPIN_SUFFIX = '(Drop-In)'
export const DROPIN_QUERY_PARAM = 'dropin'

export const HIGHLY_ENGAGING_SESSION_TALK_TIME_PERCENTAGE = 90
export const HIGHLY_ENGAGING_SESSION_MIN_TOTAL_TALK_TIME_SECONDS = 60 * 5

export const SUMMER_CAMP_EXCLUDED_TOPICS = [SAT_BOOTCAMP_ONBOARDING_TOPIC]
